import React from "react";
import './styles.css';
/*const techCompanies = [
    { value: 1, label: "Apple", },
    { value: 2, label: "Facebook"},
];*/

// Reusable Dropdown
class NuListSearch extends React.Component { 
    // selectValue => current selected value
    // options => choices in the dropdown
    // setFilteredData => function to change the selectValue
    state = {
      form: {
        key: '',
      }, 
    }
    //------------------------------------
    //----------------especial, actualiza valores del form -------------------------------
    handleChangeForm = (e) => {
      //requerimos la prop name='?' en cada control
      this.setState({
        form: {
          ...this.state.form,
          [e.target.name]: e.target.value,
        },
      });
    };
    handleKeyPress = (event) => {
      if(event.key === 'Enter'){
        //console.log('enter press here! ')
        this.props.onClickBtn(this.state.form.key);
      }
    }
    //------------------------------------------
    onClickItem = (e,item) => {
      console.log("onClickItem")
      /*e.target.name = this.props.name;
      e.target.value = item.value;
      this.props.onChange(e);*/
      this.props.onClickItem(item);
    }; 
    //---------------------------------------------
    searchClick =(e)=>{
      console.log("searchClick");
      this.props.onClickBtn(this.state.form.key); 
    }
    //=======================================
    render() {
       const { value=0, options=[], placeholder='', titulo='' } = this.props;

       //const miClassName = `nu-sidenav_item ${ value===item.value? "menu-item--active":'' }`;
       
       return (
        <div>
          {titulo}
          {
            //JSON.stringify(this.state.form)
          }
          <div className="input-group flex-fill">
              <input  type="search" 
                      name="key" 
                      value={this.state.form.key} 
                      placeholder={placeholder} 
                      className="form-control" 
                      autoComplete="off"
                      onKeyPress={this.handleKeyPress}
                      onChange= {this.handleChangeForm} 
                      />
              <div className="input-group-append">
                <button type="button" 
                        value="Buscar" 
                        className="btn btn-primary" 
                        data-disable-with="Search"
                        onClick= {this.searchClick} 
                        >
                    <i className="fa fa-search"></i>
                </button>
              </div> 

          </div>
          {/*<!-------------------->*/}
          <div className="listab" style={{ backgroundColor: '#e7e7e7'}}>
            {options.map( (item, index) => {
              return (
                <div key={ index } 
                      className={ `link_a ${ value===item.value? "item--active":'' }` }
                      onClick={ (e)=> this.onClickItem(e,item) } 
                > {item.label}   </div>
              )
            })
            }
          </div>

        
        </div>
        );
     }
};
export default NuListSearch;